import { render, staticRenderFns } from "./MiniProgramRuiShiLiGouWuOrderYearlyPayment.vue?vue&type=template&id=17b1e88b&scoped=true&"
import script from "./MiniProgramRuiShiLiGouWuOrderYearlyPayment.vue?vue&type=script&lang=js&"
export * from "./MiniProgramRuiShiLiGouWuOrderYearlyPayment.vue?vue&type=script&lang=js&"
import style0 from "./MiniProgramRuiShiLiGouWuOrderYearlyPayment.vue?vue&type=style&index=0&id=17b1e88b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b1e88b",
  null
  
)

export default component.exports